import _ from 'lodash'
import * as THREE from 'three'

import Config from '@glass-designer/config'
import BaseObject from './baseObject'
import MathsUtils from '@/utils/mathsUtils'
import GlassSegment from '@/model/glassSegment'

import EditorTypes from '../types'
import { SegmentTypes } from '@/store/mathTypes'


// Dragging Object
// An object to display any type of object being dragged around just by the segment lists / shapes
export default class DraggingObject extends BaseObject {
  constructor(editor, options = {}) {
    super(editor)

    this.position = new THREE.Vector2(0, 0, 0)

    this.segmentListGroupList = []
    this.outlineGeom = null
    this.shapeObj = null

    this.sceneObject = new THREE.Object3D()
  }

  // Dispose
  dispose() {
    super.dispose()

    if(this.outlineGeom) {
      this.outlineGeom.dispose()
      this.outlineGeom = null
    }
    this.shapeObj = null
  }

  // onBeforeRender
  // Called prior to rendering of the object
  onBeforeRender() {
    super.onBeforeRender()

    if(this.shapeObj)
      this.shapeObj.position.set(this.position.x, this.position.y, 99)
  }


  // Update the position of the cutout
  setPosition(pos) {
    this.position.set(pos.x, pos.y)
  }


  /**
   * Clear the list of segment list groups
   */
  clearSegmentListGroups() {
    this.segmentListGroupList = []
    this.updateSceneObject()
  }


  /**
   * Add a group to the dragging object with a segment list
   */
  addSegmentListGroup(offsetPoint, segmentList) {
    this.segmentListGroupList.push(segmentList.map(segment => {
      let outSegment = segment.clone()
      outSegment.moveSegment(offsetPoint)
      return outSegment
    }))
    this.updateSceneObject()
  }


  /**
   * Add a group to the dragging object based on a rectangle
   */
  addRectangleGroup(centerPoint, width, height) {
    let rectSegmentList = [
      new GlassSegment(SegmentTypes.line, { startPosition: new THREE.Vector2(-width/2, -height/2), endPosition: new THREE.Vector2(width/2, -height/2) }),
      new GlassSegment(SegmentTypes.line, { startPosition: new THREE.Vector2(width/2, -height/2), endPosition: new THREE.Vector2(width/2, height/2) }),
      new GlassSegment(SegmentTypes.line, { startPosition: new THREE.Vector2(width/2, height/2), endPosition: new THREE.Vector2(-width/2, height/2) }),
      new GlassSegment(SegmentTypes.line, { startPosition: new THREE.Vector2(-width/2, height/2), endPosition: new THREE.Vector2(-width/2, -height/2) }),
    ]

    this.addSegmentListGroup(centerPoint, rectSegmentList)
  }


  // Update the scene object
  updateSceneObject() {
    var shapeDivisions = Config.Settings.arcSubdivisions

    this.clearSceneObject()

    if(this.outlineGeom) {
      this.outlineGeom.dispose()
      this.outlineGeom = null
    }

    var vertices = []

    this.segmentListGroupList.forEach(segmentList => {
      let shapePath = MathsUtils.generateShapeFromSegmentList(segmentList)

      let shapePoints = shapePath.getPoints(shapeDivisions)
      for(var i = 0; i < shapePoints.length - 1; i++)
        vertices.push(shapePoints[i].x , shapePoints[i].y, 0, shapePoints[(i + 1) % shapePoints.length].x , shapePoints[(i + 1) % shapePoints.length].y, 0)
    })

    if(vertices.length == 0)
      return

    // Build the shape object from the hole shape data
    this.outlineGeom = new THREE.BufferGeometry()
    this.outlineGeom.setAttribute( 'position', new THREE.Float32BufferAttribute(vertices, 3))

    var outerMaterial = new THREE.LineBasicMaterial({
      color: this.editor.getTheme().dragObjectColour,
      transparent: true,
      opacity: this.editor.getTheme().dragObjectOpacity
    })
    this.shapeObj = new THREE.LineSegments(this.outlineGeom, outerMaterial)
    this.sceneObject.add(this.shapeObj)
  }


}
